import Http from '@/services/Http';
import type { AxiosInstance } from 'axios';

export default class Api extends Http {
  static base = '';

  static build(path = '', options: Record<string, unknown> = {}, http: AxiosInstance | null = null) {
    return new this(Api.normalize(Api.base, path), options, http);
  }
}
